import { Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';
import { useNavigate } from "react-router-dom";

const SystemIntegrationPage = () => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate('bot-calculator');
  }

  return (
    <Stack direction="row">
      <Card
        onClick={handleNavigation}
        sx={{
          // height: 1,
          border: 1,
          borderColor: "grey.200",
        }}
      >
        <CardActionArea
          sx={{
            p: 2,
            height: 1,
            display: "flex",
            alignItems: "start",
            justifyContent: "start",
            columnGap: 2,
          }}
        >
          <CalculateRoundedIcon color="primary" />
          <CardContent sx={{ p: 0 }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", fontSize: 18 }}
            >
              Bot Calculator
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Create or edit Bot Calculation Configurations
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Stack>
  );
};

export default SystemIntegrationPage;
